document.addEventListener("turbo:load", () => {
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
  );

  document.querySelectorAll("[title]").forEach(function (el) {
    new bootstrap.Tooltip(el);
  });
});
